import React, { Component } from 'react';

import LoginForm from './Form';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('LOGIN_PAGE', LOG_LEVELS.DEBUG);

class LoginPage extends Component {
  
	render() {
		log.debug('render(): ', this.props, this);

    return (
			<div className="avalara-hero">
        <LoginForm
          onSuccessHandler={this.props.onSuccessHandler}
          onFailHandler={this.props.onFailHandler}
          history={this.props.history}
        />
      </div>
		)
  }
}


export default LoginPage;